import WaiterOptionGroups from '../../components/WaiterOptionGroups'
import * as optionGroupsActions from '../../actions/components/optionGroups'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import styles from '../../assets/styles/components/OptionGroups'
import injectSheet from 'react-jss'

const mapStateToProps = (state) => {
  const stash = state.stash
  const user = state.user
  const merchant = state.merchant
  const isTakeaway = state.isTakeaway
  const stashByOptionGroups = state.stashByOptionGroups
  const stashByRadioGroups = state.stashByRadioGroups
  return {
    user,
    merchant,
    stash,
    isTakeaway,
    stashByOptionGroups,
    stashByRadioGroups,
  }
}

const mapDispatchToProps = (dispatch) => {
  const {
    addStashByOptionGroups,
    removeStashByOptionGroups,
    addStashByRadioGroups,
  } = bindActionCreators(optionGroupsActions, dispatch)

  return {
    addStashByOptionGroups,
    removeStashByOptionGroups,
    addStashByRadioGroups,
  }
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectSheet(styles)(WaiterOptionGroups)))



// WEBPACK FOOTER //
// ./src/containers/components/WaiterOptionGroups.js